<template>
  <div class="global-search">
    <font-awesome-icon class="global-search__icon" icon="search" />
    <input
      v-model="query"
      class="global-search__input"
      type="text"
      placeholder="Поиск"
      @keydown.enter="emit"
    />
  </div>
</template>

<script>
  export default {
    name: 'GlobalSearch',
    data () {
      return { query: '' }
    },
    methods: {
      emit () {
        this.$emit('search', this.query)
      },
    },
  }
</script>

<style lang="less" scoped>
.global-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  min-width: 220px;

  &__icon {
    color: #888;
    font-size: 14px;
  }

  &__input {
    flex: 1 1 auto;
    border: 0;
    outline: 0;
    font-size: 14px;
    background: transparent;
  }
}
</style>
